import * as React from 'react';
import clsx from 'clsx';
import { useInstantSearch } from 'react-instantsearch';

import { useSearchListContext } from '../context/SearchListProvider';
import SearchFacet from './SearchFacet';

const SearchFilter = () => {
  const { facets } = useSearchListContext();
  const { indexUiState } = useInstantSearch();
  const [toggle, setToggle] = React.useState(false);

  return facets && facets.length && indexUiState.query ? (
    <div className="search-list__filter">
      <button
        type="button"
        className="button button--black button--back button--has-icon button--reverse search-list__filter-toggle"
        aria-expanded={toggle}
        aria-controls="searchFilters"
        onClick={() => setToggle(!toggle)}
      >
        <span className="button__icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.99968 10.2271L13.6133 4.61353L14.8861 5.88632L7.99968 12.7727L1.11328 5.88632L2.38607 4.61353L7.99968 10.2271Z"
            />
          </svg>
        </span>
        <span className="typo-button button__label">Filter</span>
      </button>

      <div
        id="searchFilters"
        className={clsx('search-list__facets', {
          'hide-visually': !toggle
        })}
      >
        {facets.map((item) => (
          <SearchFacet
            key={item.attribute}
            label={item.label}
            attribute={item.attribute}
            sortBy={['name']}
          />
        ))}
      </div>
    </div>
  ) : null;
};

export default SearchFilter;
